/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./chains.vue?vue&type=template&id=c0b43010&scoped=true"
import script from "./chains.vue?vue&type=script&lang=js"
export * from "./chains.vue?vue&type=script&lang=js"
import style0 from "./chains.vue?vue&type=style&index=0&id=c0b43010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b43010",
  null
  
)

export default component.exports